import React from 'react';

export const MoveCreditsPrompt = ({
    activePlan,
    moveCredits,
    onChange,
    defaultPlanLabel = 'FREE',
}) => {
    return (
        <div className='space-y-6'>
            <div className='space-y-3'>
                <p className='text-sm text-texts-secondary300 leading-relaxed'>
                    Owner has an active{' '}
                    <span className='font-semibold text-texts-secondary'>
                        {activePlan.planName}
                    </span>{' '}
                    plan -{' '}
                    <span className='font-semibold text-texts-secondary'>
                        {activePlan.queriesRemaining}
                    </span>{' '}
                    queries remaining, valid until{' '}
                    <span className='font-semibold text-texts-secondary'>
                        {new Date(
                            activePlan.endDate
                        ).toLocaleDateString()}
                    </span>
                    .
                </p>

                <p className='text-sm text-texts-secondary300 leading-relaxed'>
                    Do you want to move these remaining credits and plan to the new
                    organization? The personal plan will be deactivated.
                </p>
            </div>

            <div className='space-y-3'>
                <label
                    className={`flex items-center gap-3 rounded-xl border p-4 cursor-pointer transition-colors ${!moveCredits
                            ? 'border-backgrounds-primary300 bg-backgrounds-primary100'
                            : 'border-backgrounds-border hover:border-backgrounds-primary200'
                        }`}
                >
                    <input
                        type='radio'
                        checked={!moveCredits}
                        onChange={() => onChange(false)}
                    />
                    <span className='text-sm text-texts-secondary'>
                        No, Keep {defaultPlanLabel} plan for organization
                    </span>
                </label>

                <label
                    className={`flex items-center gap-3 rounded-xl border p-4 cursor-pointer transition-colors ${moveCredits
                            ? 'border-backgrounds-primary300 bg-backgrounds-primary100'
                            : 'border-backgrounds-border hover:border-backgrounds-primary200'
                        }`}
                >
                    <input
                        type='radio'
                        checked={moveCredits}
                        onChange={() => onChange(true)}
                    />
                    <span className='text-sm text-texts-secondary'>
                        Yes, Move remaining credits to organization
                    </span>
                </label>
            </div>
        </div>
    );
};